export default {
  gewerbe: {
    hero: {
      eyebrow: 'Clients professionnels',
      title: 'Vidéosurveillance professionnelle pour besoins d’entreprise',
      lead: 'De la succursale de détail au hall de production : nous planifions, installons et entretenons des systèmes de caméras au service de votre activité. Respectueux de la vie privée, évolutif et fiable.',
    },
    types: {
      title: 'Des solutions pour votre activité',
      lead: 'Chaque secteur a ses exigences. Nous connaissons les défis typiques et planifions en conséquence.',
      items: {
        '0': { title: 'Commerces et boutiques', desc: 'Entrée, surface de vente, caisse et réserve : surveillés discrètement mais efficacement. Protection contre vol et vandalisme.', tags: { '0': 'Intérieur', '1': 'Antivol', '2': 'Caisse' } },
        '1': { title: 'Bureaux et cabinets', desc: 'Accueil, couloirs, zones sensibles et parkings, avec droits d’accès et zones privées.', tags: { '0': 'Intérieur', '1': 'Accueil', '2': 'Vie privée' } },
        '2': { title: 'Entrepôt et logistique', desc: 'Surveillance de grandes surfaces avec grand-angle et PTZ. Vue des zones de livraison, rayons et extérieurs jour et nuit.', tags: { '0': 'Intérieur', '1': 'Extérieur', '2': 'Vision nocturne' } },
        '3': { title: 'Restauration', desc: 'Entrée, comptoir, accès cuisine et extérieur : caméras robustes pour environnements humides et chauds.', tags: { '0': 'Intérieur', '1': 'Extérieur', '2': 'Robuste' } },
        '4': { title: 'Ateliers et industrie', desc: 'Les environnements plus difficiles exigent des caméras robustes. Ateliers, extérieurs et quais protégés.', tags: { '0': 'Intérieur', '1': 'Robuste', '2': 'Vision nocturne' } },
        '5': { title: 'Plusieurs sites', desc: 'Accès central à toutes les caméras depuis une seule app. Gestion des utilisateurs avec droits différenciés.', tags: { '0': 'Multi-sites', '1': 'Central', '2': 'App' } },
      },
    },
    features: {
      title: 'Fonctions pour usage professionnel',
      lead: 'Les installations commerciales exigent plus que des caméras. Nous configurons droits, plans d’enregistrement et notifications de façon professionnelle.',
      items: {
        '0': { title: 'Gestion des utilisateurs', desc: 'Des droits d’accès différents pour employés, responsables et direction. Qui peut voir quelle caméra ?' },
        '1': { title: 'Enregistrement et archivage', desc: 'Enregistreur local avec stockage redondant. Durée selon exigences opérationnelles et éventuellement légales.' },
        '2': { title: 'Notifications d’événements', desc: 'Messages push sur mouvement, franchissement de ligne ou événements définis, selon le système.' },
        '3': { title: 'Extensibilité', desc: 'Votre entreprise grandit ? Les systèmes existants peuvent généralement être étendus.' },
      },
    },
    legal: {
      eyebrow: 'Protection des données et droit',
      title: 'Vidéosurveillance d’entreprise conforme',
      lead: 'Des règles supplémentaires s’appliquent à la vidéosurveillance commerciale, notamment pour les employés, clients et zones publiques. Nous vous aidons pour la mise en œuvre technique de :',
      list: {
        '0': 'Transparence et signalétique aux entrées',
        '1': 'Masquage des vestiaires et salles de pause',
        '2': 'Mise en œuvre technique des droits d’accès et utilisateurs',
        '3': 'Stockage local avec durée de conservation définie',
        '4': 'Documentation de la nécessité opérationnelle',
      },
      note: 'Remarque : la licéité de la vidéosurveillance d’entreprise dépend du cas. Nous vous conseillons techniquement, sans remplacer le conseil juridique.',
    },
    cta: {
      title: 'Votre activité mérite une sécurité professionnelle',
      lead: 'Nous analysons vos processus et planifions un système qui protège sans déranger. Sans engagement et en toute transparence.',
      primary: 'Prendre rendez-vous',
      secondary: 'Découvrir SSG Care',
    },
  },
};